module.exports = __webpack_public_path__ + "img/grommets.86ab4dfd.svg";